import { IHUBSERVICE_TOKEN } from '../../common/src/signalR/signalRServices';
import { InaxAlarmService } from './alarm';
import { DEFAULT_ALARM_SETTINGS } from './config/default/defaultAlarmSettings';
import { ALARM_CONFIG_TOKEN } from './config/alarmConfig';




export const ALARM_HUBSERVICEPROVIDER_ENTRY = { provide: IHUBSERVICE_TOKEN, useClass: InaxAlarmService, multi: true };
export const ALARM_CONFIG_PROVIDER_ENTRY = { provide: ALARM_CONFIG_TOKEN, useValue: DEFAULT_ALARM_SETTINGS, multi: false };

export const DEFAULT_ALARM_PROVIDER_ENTRIES = [
        ALARM_HUBSERVICEPROVIDER_ENTRY,
        ALARM_CONFIG_PROVIDER_ENTRY,
]